import adminRoutes from 'routes/routesByRole/adminRoutes';
import PATH from 'routes/paths';

const COORDINATOR_EXCLUDED_PATHS = [
  PATH.INTERNAL_REQUEST.LIST,
  PATH.INTERNAL_REQUEST.ONE,
  PATH.SETTINGS.INTERNAL_REQUESTS,
];

const coordinatorRoutes = adminRoutes.filter(
  (route) => !COORDINATOR_EXCLUDED_PATHS.includes(route.path)
);

export default coordinatorRoutes;
